'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var FeaturedVideo = require('./FeaturedVideo.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var VideoUrlTextBox =
/*#__PURE__*/
function (_PureComponent) {
  inherits(VideoUrlTextBox, _PureComponent);

  function VideoUrlTextBox(props) {
    var _this;

    classCallCheck(this, VideoUrlTextBox);

    _this = possibleConstructorReturn(this, getPrototypeOf(VideoUrlTextBox).call(this, props));
    _this.state = {
      url: ObjectHelper.isPresent(_this.props.oldId) ? "https ://www.youtube.com/watch?v=".concat(_this.props.oldId) : '',
      videoId: _this.props.oldId,
      preview: ObjectHelper.isPresent(_this.props.oldId)
    };
    return _this;
  }

  createClass(VideoUrlTextBox, [{
    key: "getYoutubeId",
    value: function getYoutubeId(youtubeUrl) {
      if (ObjectHelper.isBlank(youtubeUrl)) {
        return null;
      }

      var regex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;

      if (regex.test(youtubeUrl)) {
        var match = youtubeUrl.match(regex);
        return match.length > 7 && match[7].length == 11 ? match[7] : null;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          disableSave = _this$props.disableSave;
      this.setState({
        url: value
      });
      var youtubeId = this.getYoutubeId(value) || '';
      this.setState({
        videoId: youtubeId,
        preview: ObjectHelper.isPresent(youtubeId)
      });
      onChange(youtubeId);
      disableSave(ObjectHelper.isBlank(youtubeId) && ObjectHelper.isPresent(value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          videoId = _this$state.videoId,
          preview = _this$state.preview,
          url = _this$state.url;
      return React__default["default"].createElement(Grid["default"], {
        item: true,
        xs: 12
      }, React__default["default"].createElement(TextField["default"], {
        id: "video_url",
        placeholder: 'Enter a Youtube url',
        fullWidth: true,
        margin: "normal",
        variant: "outlined",
        InputLabelProps: {
          shrink: true
        },
        value: url,
        onChange: function onChange(event) {
          return _this2.handleChange(event.target.value);
        },
        autoFocus: true
      }), preview && React__default["default"].createElement(FeaturedVideo, {
        videoId: videoId
      }));
    }
  }]);

  return VideoUrlTextBox;
}(React.PureComponent);
VideoUrlTextBox.defaultProps = {
  oldId: ''
};

module.exports = VideoUrlTextBox;
